import { Color, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import { VatDeclarationsReportPart } from '@features/vatDeclarations/types/vatDeclarationsReportPart'
import { VatDeclarationsReportSection as VatDeclarationsReportSectionType } from '@features/vatDeclarations/types/vatDeclarationsReportSection'

import { Table } from '../Table'
import * as Styled from './styles'

interface SectionProps {
  reportSegment: VatDeclarationsReportSectionType | VatDeclarationsReportPart
}

export const Section = ({ reportSegment }: SectionProps): ReactElement => {
  const renderReportSegments = useCallback(() => {
    if ('sections' in reportSegment) {
      return reportSegment.sections.map((reportSection) => (
        <Table
          reportSection={reportSection}
          key={reportSection?.symbol ? `${reportSection?.symbol}-${reportSection?.name}` : reportSection.name}
        />
      ))
    } else if ('fields' in reportSegment) {
      return <Table reportSection={reportSegment} showTitle={false} />
    }
  }, [reportSegment])

  return (
    <>
      <thead>
        <Styled.HeadRow>
          <Styled.HeadCell>
            <Text weight="bold" color={Color.White} variant="bodyLG">
              {reportSegment.symbol}
            </Text>
          </Styled.HeadCell>
          <Styled.HeadCell colSpan={3}>
            <Text weight="bold" color={Color.White} variant="bodyLG">
              {reportSegment.name}
            </Text>
          </Styled.HeadCell>
        </Styled.HeadRow>
      </thead>
      <tbody>{renderReportSegments()}</tbody>
    </>
  )
}
